export enum ModalMode {
  EDIT = 'Edit',
  CREATE = 'Create',
  VIEW = 'View',
}

export enum AssigneeUsersType {
  INTERVENTIONS = 'Interventions',
}
